(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ggm2-gift-type-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ggm2-cat-carousel__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = btn.getAttribute('data-target');
      var dir = parseInt(btn.getAttribute('data-direction'), 10) || 1;
      var track = document.getElementById(id);
      if (track) track.scrollBy({ left: dir * 320, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-faq-schema"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class WhFaqSchemaSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.$answers = this.queryAll('[data-wh-faq-answer]');
    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.updateItemHeights();
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initEventListeners() {
    this.events.register(window, 'resize', debounce(
      () => this.updateItemHeights(), 200)
    );
  }

  updateItemHeights() {
    this.$answers.forEach(($answer) => {
      const openHeight = $answer.scrollHeight;
      $answer.style.setProperty('--open-height', `${openHeight}px`);
    });
  }

  onBlockSelect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    if (!$block) return;
    const $details = $block.querySelector('[data-wh-faq-item]');
    if (!$details) return;
    $details.open = true;
    this.updateItemHeights();
  }

  onBlockDeselect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    if (!$block) return;
    const $details = $block.querySelector('[data-wh-faq-item]');
    if (!$details) return;
    $details.open = false;
  }
}

document.querySelectorAll('[data-wh-faq-schema]').forEach(($section) => {
  Section.init($section, WhFaqSchemaSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.WhFaqSchemaSection = WhFaqSchemaSection;
}

  } catch(e) { console.error(e); }
})();
})();
